import { render, staticRenderFns } from "./CustomerProfile.vue?vue&type=template&id=2c2889bd&scoped=true"
import script from "./CustomerProfile.vue?vue&type=script&lang=js"
export * from "./CustomerProfile.vue?vue&type=script&lang=js"
import style0 from "./CustomerProfile.vue?vue&type=style&index=0&id=2c2889bd&prod&lang=css"
import style1 from "./CustomerProfile.vue?vue&type=style&index=1&id=2c2889bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2889bd",
  null
  
)

export default component.exports